export function postMessageToIframe<TMessage>(
  iframe: {
    contentWindow?: { postMessage: Window['postMessage'] } | null;
  },
  origin: string,
  port: MessagePort,
  message: TMessage,
) {
  iframe.contentWindow?.postMessage(JSON.stringify(message), origin, [port]);
}

export function addSandboxAttributes(iframe: HTMLIFrameElement) {
  iframe.sandbox.add(
    'allow-storage-access-by-user-activation',
    'allow-scripts',
    'allow-same-origin',
    'allow-popups',
  );
}

export function getIframeUrl(
  interopHost: string,
  appId: string,
  bundle: string,
) {
  return `${interopHost}/api/iframe/${appId}/${bundle}`;
}
